import PedidoClienteService from "@/services/PedidoClienteService";

export const pedidoCliente = {
  namespaced: true,
  state: {
    pedidoCliente: {},
  },
  actions: {
    getPedidoCliente({ commit }, payload) {
      return PedidoClienteService.GetPedidoCliente(payload).then(
        (pedidoCliente) => {
          return Promise.resolve(pedidoCliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoCliente({ commit }, payload) {
      return PedidoClienteService.PostPedidoCliente(payload).then(
        (pedidoCliente) => {
          return Promise.resolve(pedidoCliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoCliente({ commit }, payload) {
      return PedidoClienteService.PutPedidoCliente(payload).then(
        (pedidoCliente) => {
          return Promise.resolve(pedidoCliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoCliente({ commit }, payload) {
      return PedidoClienteService.DeletePedidoCliente(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoClienteOData({ commit }, payload) {
      return PedidoClienteService.GetPedidoClienteOData(payload).then(
        (pedidoCliente) => {
          return Promise.resolve(pedidoCliente);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoCliente;
